var version = {
    "name":      "dativery",
    "buildDateCode": "20261103-110623",
    "buildDate": "Tue Nov 03 2026 11:06:23 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261103-110623",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;